import * as React from "react";
import { useLocation } from "react-router-dom";

import Paper from "../../Components/Paper";
import Tabs from "../../Components/Tabs";
import UserInfos from "./UserInfos";
import UserPassword from "./UserPassword";

import "./EditAccount.scss";
import { useConnectedUser } from "../../Context/ConnectedUserContext";
import OtpCODE from "./OtpCODE";

const EditAccount = () => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [activeSendOtp, setActiveSendOtp] = React.useState(true);
  const { isFirstTimeConnect } = useConnectedUser();

  const { state } = useLocation();

  React.useEffect(() => {
    if (isFirstTimeConnect) setActiveTab(0);
    else if (!!state?.tabId) {
      window.history.replaceState({}, document.title);
      setActiveTab(state.tabId === "security" ? 1 : 0);
    }
  }, [state, isFirstTimeConnect]);

  return (
    <div className="editAccount-page">
      <Paper>
        <Tabs
          items={
            isFirstTimeConnect
              ? ["Mot de passe"]
              : [
                  "Informations personnelles",
                  activeSendOtp ? "Mot de passe" : "OTP",
                ]
          }
          active={activeTab}
          onClickTab={setActiveTab}
        >
          {!isFirstTimeConnect && <UserInfos />}
          {activeSendOtp ? (
            <UserPassword setActiveSendOtp={setActiveSendOtp} />
          ) : (
            <OtpCODE />
          )}
        </Tabs>
      </Paper>
    </div>
  );
};

export default EditAccount;
